import { useTranslation } from 'react-i18next';

function FolkynLogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M15.6233 2.57684C28.2604 1.47373 36.9586 14.603 30.6658 25.4342C25.1178 34.9831 11.3165 35.6139 4.69065 26.8023C-2.38785 17.3881 3.6643 3.62072 15.6233 2.57684ZM16.0744 8.05241C7.86659 9.02078 5.18566 21.1802 11.4119 25.8562C13.9717 27.7796 15.2736 23.185 17.626 23.7758C19.8104 24.3237 20.316 27.898 23.224 25.5586C29.7939 20.2725 26.0321 6.87675 16.0744 8.05241Z"
        fill="#FFC44D"
      />
      <path
        d="M18.4421 19.7781C16.6234 21.6182 13.684 19.2082 15.2131 17.0181C16.9451 14.5383 20.7366 17.458 18.4421 19.7781Z"
        fill="white"
      />
    </svg>
  );
}

export function AppLoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="relative mx-auto h-16 w-16">
          <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-[#20766F]/15 border-t-[#20766F]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <FolkynLogoMark className="h-9 w-9" />
          </div>
        </div>
        <p className="mt-6 text-lg font-medium text-gray-600">{t('common.loading')}</p>
      </div>
    </div>
  );
}
